// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"8":"mobile","761":"PC"}[chunkId] || chunkId) + "." + {"8":"634ec3cc","69":"3309ee94","761":"dd202975"}[chunkId] + ".js";
};